const data = {
	"width": 666,
	"height": 680,
	"body": "<path fill=\"currentColor\" d=\"M0 311h297V14H0v297zm369 0h297V14H369v297zM0 680h297V383H0v297zm369 0h297V383H369v297z\"/>"
};
exports.__esModule = true;
exports.default = data;
